import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SCDUser } from '@shs-digi-care-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class SCDService {
    private readonly httpClient = inject(HttpClient);
    private readonly apiURL = `${environment.apiUrl}/users`;

    public getUserByGid(gid: string): Observable<SCDUser> {
        return this.httpClient.get<SCDUser>(`${this.apiURL}/scd`, { params: { gid } });
    }

    public getUserByFirstAndLastName(firstName: string, lastName: string): Observable<SCDUser> {
        return this.httpClient.get<SCDUser>(`${this.apiURL}/scd`, { params: { firstName, lastName } });
    }
}
